var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');
var sw =  require('js/lib/sw');
var defaultTpl = require('rrViewComponents/Form/Input/DropdownInputComponent/tpl.dropdown-input-component-vue.mustache');
var minimalTrackingTpl = require('rrViewComponents/Form/Input/DropdownInputComponent/tpl.minimal-dropdown-input-component-with-tracking-vue.mustache');

var mountedFragment = function mountedFragment() {
  this.$nextTick(function () {
    var _this = this;
    var $el = $(this.$el);
    sw.trigger('sw-fragment-loaded', $el);
    // Listen to changes in the selectric dropdown and pass it to the the Vue object method
    $el.on('selectric-change', function(e, el) {
      _this.dispatchInputEvent(el.value);
    });
  });
};


var THRESHOLD_ATTR = 'data-sw-dropdown-input-threshold';
var THRESHOLD_INPUT_VALUE = 'data-sw-dropdown-input-value';
var THRESHOLD_INPUT = 'data-sw-dropdown-input';
var TEMPLATE_ATTR = 'data-sw-dropdown-input-tpl-type';
var MINIMAL_TRACKING_TEMPLATE_TYPE = 'minimal-tracking';

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-dropdown-input]').each(function() {
    var $this = $(this);
    var threshHold = $this.attr(THRESHOLD_ATTR);
    var inputValue = $this.attr(THRESHOLD_INPUT_VALUE);
    var qauntitySelectName = $this.attr(THRESHOLD_INPUT);
    var templateType = $this.attr(TEMPLATE_ATTR);
    var isDisabled = $this.is(':disabled');

    // Defaults to normal input, can opt to use the minimal template
    var tpl = defaultTpl;
    if (templateType === MINIMAL_TRACKING_TEMPLATE_TYPE) {
      tpl = minimalTrackingTpl;
    }

    /**
     * In order to get selectric to work with Vue, we render a string template
     * separately, then pass it to the Vue constructor to avoid Vue template
     * issues when Selectric manipulates the DOM.
     */
    var tplData = {
      getQuantitySelectName: qauntitySelectName,
      getInputValue: threshHold,
      disabled: isDisabled,
      getQuantityOptions: function() {
        var quantityOptions = [];
        for (var i = 1; i < parseInt(threshHold); i++){
          quantityOptions.push({
            value: i,
            text: i
          });
        }
        quantityOptions.push({
          value: threshHold,
          text: threshHold + '+'
        });
        return quantityOptions;
      }
    };
    var template = tpl.render(tplData);

    new Vue({
      el: this,
      data: {
        inputValue: inputValue,
        threshHold: threshHold,
        showInput: parseInt(inputValue) >= threshHold
      },
      template: template,
      mounted: mountedFragment,
      methods: {
        dispatchInputEvent: function dispatchInputEvent(value) {
          this.inputValue = value;
          this.showInput = parseInt(this.inputValue) >= this.threshHold;
        }
      }
    });
  });
};
